// extracted by mini-css-extract-plugin
export default {"centeredSlider":"BannerText_centeredSlider__icaWZ","imageHeight":"BannerText_imageHeight__nUwiY"};